<p bitTypography="body1" class="tw-mb-0">
  {{ "openExtensionFromToolbarPart1" | i18n }}
  <img
    src="images/icons/brackets-vault/Logomark.svg"
    alt=""
    class="bv-setup-extension-toolbar-icon"
    aria-hidden="true"
  />
  {{ "openExtensionFromToolbarPart2" | i18n }}
</p>
